import { DeskConstants } from './DeskConstants';
import { blipCopilotSettingsSource, blipWebsocketHostName, messaginghubWebsocketHostName, blipWebsocketHostNameTenant, transcriptionSettingsSource, } from 'app.constants';
import { messaginghubWebsocketHostNameTenant } from 'app.constants';
export class BlipCopilotController {
    static $inject = ['$state', 'LoadingService', 'TranslateService', 'application', 'AccountService2', 'PermissionsService'];
    constructor($state, LoadingService, TranslateService, application, AccountService2, PermissionsService) {
        'ngInject';
        this.$state = $state;
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.application = application;
        this.AccountService2 = AccountService2;
        this.PermissionsService = PermissionsService;
        this.LoadingService.startLoading();
        const setProps = async () => {
            this.canEditDesk = await this.PermissionsService.hasPermissions(DeskConstants.WRITE, DeskConstants.DESK);
            const account = await this.AccountService2.me();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = this.application.shortName;
            this.webSocketParams = {
                messaginghubWebsocketHostNameTenant,
                messaginghubWebsocketHostName,
                blipWebsocketHostName,
                blipWebsocketHostNameTenant,
            };
            this.LoadingService.stopLoading();
            this.settingsSource = blipCopilotSettingsSource;
            this.transcriptionMfeSettingsSource = transcriptionSettingsSource;
            this.user = account.identity;
            this.width = this.$state.current.data.width;
        };
        setProps();
    }
}
BlipCopilotController.$inject = ['$state', 'LoadingService', 'TranslateService', 'application', 'AccountService2', 'PermissionsService'];
